import { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import { UnifiedLoadingScreen } from "./UnifiedLoadingScreen";

interface AuthBootstrapGateProps {
  children: ReactNode;
}

export const AuthBootstrapGate = ({ children }: AuthBootstrapGateProps) => {
  const { isBootstrapping } = useAuth();

  return (
    <>
      {children}
      {isBootstrapping && (
        <UnifiedLoadingScreen visible progress={0} stage="Restoring your session..." />
      )}
    </>
  );
};
